import { Link } from 'react-router-dom';
import clinic from '@/data/clinic';

const quickLinks = [
  ['Home', '/'],
  ['Treatments', '/treatments'],
  ['Conditions', '/conditions'],
  ['About Dr. Ankit', '/about-doctor'],
  ['Patient Reviews', '/reviews'],
  ['Blog', '/blog'],
  ['Contact', '/contact'],
];

const popularTreatments = [
  ['Panchakarma', '/treatments/panchakarma'],
  ['Agnikarma', '/treatments/agnikarma'],
  ['Shirodhara', '/treatments/shirodhara'],
  ['Nadi Parikshan', '/treatments/naadi-parikshan'],
  ['Basti', '/treatments/basti'],
  ['Leech Therapy', '/treatments/leech-therapy'],
];

const Footer = () => (
  <footer className="site-footer" data-testid="site-footer">
    <div className="footer-inner">
      <div className="footer-grid footer-grid-4">
        <div>
          <div className="footer-logo-circle">
            <img src="/siddhayu-logo.png" alt="Siddhayu Ayurvedic Clinic logo" />
          </div>
          <span className="footer-logo-name">सिद्धायु आयुर्वेद</span>
          <span className="footer-tagline">"Heal at the Root."</span>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.8rem', marginTop: '0.75rem', fontFamily: 'var(--font-body)', lineHeight: 1.5 }}>
            {clinic.doctor}, BAMS<br />
            Nallasopara East, Palghar, Maharashtra
          </p>
        </div>
        <div>
          <p className="footer-col-title">Quick Links</p>
          <ul className="footer-nav-links">
            {quickLinks.map(([label, to]) => (<li key={to}><Link to={to}>{label}</Link></li>))}
          </ul>
        </div>
        <div>
          <p className="footer-col-title">Popular Treatments</p>
          <ul className="footer-nav-links">
            {popularTreatments.map(([label, to]) => (<li key={to}><Link to={to}>{label}</Link></li>))}
          </ul>
        </div>
        <div>
          <p className="footer-col-title">Contact</p>
          <div className="footer-contact-text">
            <p><a href={`tel:${clinic.phoneE164}`}>📞 {clinic.phoneDisplay}</a></p>
            <p style={{ marginTop: '0.35rem' }}>Sai Shradha Apt, Shop No. 5,<br />Vijay Nagar, Nallasopara East 401209</p>
            <a href={clinic.waLink()} className="footer-wa-btn" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-btn">💬 WhatsApp Us</a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        © 2026 Siddhayu Ayurvedic Clinic &amp; Panchakarma Centre · {clinic.doctor} · BAMS · {clinic.registration}
        <p className="growtharch-credit">Designed &amp; Developed by <span className="growtharch-name">GROWTHARCH</span></p>
      </div>
    </div>
  </footer>
);

export default Footer;
